import { connect } from 'react-redux';
import { getLoadingDivisionsSelector } from 'redux-core/divisions/selectors';

const mapStateToProps = (state) => ({
  loading: getLoadingDivisionsSelector(state),
});

export default connect(mapStateToProps);
